// extracted by mini-css-extract-plugin
export default {"PhoneAuth":"PhoneAuthGroup_PhoneAuth__BO4-0"};